import { isPlaygroundEnvironment } from './isPlaygroundEnvironment';

/**
 * Whether the Playground entry should appear in admin nav.
 * Requires both admin profile (caller passes `isAdmin`) and an allowlisted env.
 */
export function shouldShowPlaygroundNav(isAdmin: boolean): boolean {
  return isAdmin && isPlaygroundEnvironment();
}
